module.exports = "/desktop-app/assets/img/no-branch.png?175f7422961afca2b87fd767528fcf34";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/images/icon/no-branch.png
// module id = 6h7V
// module chunks = 1